import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getEntries } from "../../../services/users";
import AddEditEntrySleep from "../../Entries/Entry/AddEditEntrySleep";

interface props {
	user: any;
	dateTS: any;
}

const DateSleepView: React.FC<props> = ({ dateTS, user }) => {
	const [entries, setEntries] = useState<any>([]);

	useEffect(() => {
		if (!user.id) user.id = user.uid;
		if (user && user.id && dateTS) {
			getEntries(user.id).then((docs: any) => {
				let validEntries = Object.values(docs).filter(
					(doc: any) => doc.dateTS === dateTS
				);
				setEntries(validEntries);
			});
		}
	}, [user]);

	const _getSleepEntryID = () => {
		return entries.length > 0 ? entries[0].id : "";
	};

	return (
		<>
			<AddEditEntrySleep user={user} eid={_getSleepEntryID()} dateTS={dateTS} />
		</>
	);
};

const mapStateToProps = (state: any) => ({
	usersData: state.user.users,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DateSleepView);
